module.exports = __webpack_public_path__ + "img/avatar6.241db7ec.png";